/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Inventory_HealthInputs */

const vi_dashboard_manager_inventory_health = /** @type {(inputs: Dashboard_Manager_Inventory_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sức khoẻ tồn kho`)
};

/**

* @param {Dashboard_Manager_Inventory_HealthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_inventory_health = /** @type {((inputs?: Dashboard_Manager_Inventory_HealthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Inventory_HealthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_inventory_health(inputs)
});